export function animation() {
    let $animContainer = $(".animation");
    let $win = $(window);
    let classNameAnimated = "animated";

    function isInViewport(obj, coefficientOffsetVH) {
        let offsetTop = parseInt(obj.offset().top);
        let winScrollTop = $win.scrollTop();
        let bottomPosition = parseInt(offsetTop + obj.outerHeight());
        let winHeight = $win.height();
        let diffHeight = coefficientOffsetVH == 0 ? -5 : winHeight / 100 * coefficientOffsetVH;

        return !(bottomPosition < winScrollTop || offsetTop - diffHeight > winScrollTop + winHeight);
    }

    function addAnimation(obj) {
        obj.each(function () {
            let cur = $(this);

            if (!cur.hasClass(classNameAnimated)) {

                let classList = classNameAnimated;

                if (isInViewport(cur, 0)) {

                    setTimeout(() => {
                        cur.addClass(classList);
                    }, 400);
                }
            }
        });
    }

    $(document).ready( function () {
        addAnimation($animContainer);
    });

    $win.on("scroll", function () {
        addAnimation($animContainer);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/animation.js